import { service } from "../utils/request";

// 平台卡
//列表
export function platformcard_card_list(data) {
  return service({
    url: "manage/platformcard.card/card_list",
    method: "get",
    params: data
  });
}
//用户平台卡列表
export function platformcard_card_userlist(data) {
  return service({
    url: "manage/platformcard.card/card_data_user_list",
    method: "get",
    params: data
  });
}
//用户平台卡失效
export function disable_card_data_user(data) {
  return service({
    url: "manage/platformcard.card/disable_card_data_user",
    method: "post",
    data: data
  });
}
//详情
export function platformcard_card_detail(data) {
  return service({
    url: "manage/platformcard.card/card_detail",
    method: "get",
    params: data
  });
}
//参加平台卡
export function platformcard_join_card(data) {
  return service({
    url: "manage/platformcard.card/join_card",
    method: "post",
    data: data
  });
}
//设置平台卡
export function platformcard_set_card(data) {
  return service({
    url: "manage/platformcard.card/set_card",
    method: "post",
    data: data
  });
}
//订单
//列表
export function card_order_list(data) {
  return service({
    url: "manage/platformcard.card/card_order_list",
    method: "get",
    params: data
  });
}
//详情
export function card_order_detail(data) {
  return service({
    url: "manage/platformcard.card/card_order_detail",
    method: "get",
    params: data
  });
}
//使用记录
export function card_order_user_logs(data) {
  return service({
    url: "manage/platformcard.card/card_order_user_logs",
    method: "get",
    params: data
  });
}
// 平台卡统计
export function card_order_count(data) {
  return service({
    url: "manage/platformcard.card/card_order_count",
    method: "get",
    params: data
  });
}
// 平台卡退款
export function card_order_refund(data) {
  return service({
    url: "manage/platformcard.card/refund",
    method: "post",
    data
  });
}
